if (!window.BracketIndicator) {
  window.BracketIndicator = class BracketIndicator {
    constructor({ container, items, className, insetX = 0, insetY = 0, getRestingItem, fillContainerWhenEmpty = false }) {
      this.container = container;
      this.items = items;
      this.className = className;
      this.insetX = insetX;
      this.insetY = insetY;
      this.getRestingItem = getRestingItem;
      this.fillContainerWhenEmpty = fillContainerWhenEmpty;
      this.target = null;

      this.el = container.querySelector(`:scope > .${className}`);
      if (!this.el) {
        this.el = document.createElement('span');
        this.el.className = `${className} ${className}--no-transition`;
        this.el.setAttribute('aria-hidden', 'true');
        container.prepend(this.el);
      }

      this.itemHandlers = items.map((item) => {
        const handler = () => this.show(item);
        item.addEventListener('mouseenter', handler);
        item.addEventListener('focus', handler);
        return handler;
      });

      this.onLeave = () => this.show(this.getRestingItem());
      this.onFocusOut = (event) => {
        if (this.container.contains(event.relatedTarget)) return;
        this.show(this.getRestingItem());
      };
      container.addEventListener('mouseleave', this.onLeave);
      container.addEventListener('focusout', this.onFocusOut);

      this.resizeObserver = new ResizeObserver(() => this.place(this.target));
      this.resizeObserver.observe(container);

      requestAnimationFrame(() => {
        this.show(getRestingItem());
        requestAnimationFrame(() => this.el.classList.remove(`${className}--no-transition`));
      });
    }

    show(item) {
      this.target = item;
      this.place(item);
    }

    place(item) {
      if (item) {
        this.el.style.left = `${item.offsetLeft - this.insetX}px`;
        this.el.style.top = `${item.offsetTop - this.insetY}px`;
        this.el.style.width = `${item.offsetWidth + this.insetX * 2}px`;
        this.el.style.height = `${item.offsetHeight + this.insetY * 2}px`;
      } else if (this.fillContainerWhenEmpty) {
        this.el.style.left = '0';
        this.el.style.top = '0';
        this.el.style.width = `${this.container.clientWidth}px`;
        this.el.style.height = `${this.container.clientHeight}px`;
      } else {
        return;
      }
      this.el.classList.add(`${this.className}--visible`);
    }

    destroy() {
      this.items.forEach((item, i) => {
        item.removeEventListener('mouseenter', this.itemHandlers[i]);
        item.removeEventListener('focus', this.itemHandlers[i]);
      });
      this.container.removeEventListener('mouseleave', this.onLeave);
      this.container.removeEventListener('focusout', this.onFocusOut);
      this.resizeObserver.disconnect();
    }
  };
}
